<div class="sh-page-template__main__actions">
  <div class="sh-action-group -sh-align-end -sh-wrap">
    @for (item of (actionItems$ | async); track item) {
      <sh-action-item class="sh-action-group__item" [item]="item"></sh-action-item>
    }
  </div>
</div>
